'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagXkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28.001 0H0.000976562V20H28.001V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28.001 0H0.000976562V20H28.001V0Z", fill: "#2F5FBF" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0011 4.66669L11.0583 4.94283L11.3344 4.00002L11.0583 3.05721L12.0011 3.33335L12.9439 3.05721L12.6677 4.00002L12.9439 4.94283L12.0011 4.66669ZM16.0011 4.66669L15.0583 4.94283L15.3344 4.00002L15.0583 3.05721L16.0011 3.33335L16.9439 3.05721L16.6677 4.00002L16.9439 4.94283L16.0011 4.66669ZM20.0011 6.00002L19.0583 6.27616L19.3344 5.33335L19.0583 4.39054L20.0011 4.66669L20.9439 4.39054L20.6677 5.33335L20.9439 6.27616L20.0011 6.00002ZM22.6677 8.66669L21.7249 8.94283L22.0011 8.00002L21.7249 7.05721L22.6677 7.33335L23.6106 7.05721L23.3344 8.00002L23.6106 8.94283L22.6677 8.66669ZM5.33441 8.66669L4.3916 8.94283L4.66774 8.00002L4.3916 7.05721L5.33441 7.33335L6.27722 7.05721L6.00108 8.00002L6.27722 8.94283L5.33441 8.66669ZM8.00108 6.00002L7.05827 6.27616L7.33441 5.33335L7.05827 4.39054L8.00108 4.66669L8.94389 4.39054L8.66774 5.33335L8.94389 6.27616L8.00108 6.00002Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.001 13.3333L10.6676 12.6667L9.33431 10H10.6676L12.001 8.66667L12.6676 7.33333L14.001 6.66667L14.6676 7.33333L16.001 8V8.66667L16.6676 9.33333L18.6676 10.6667L18.001 12.6667L16.001 14.6667L15.3343 13.3333L13.3343 14.6667V16L12.6676 15.3333L12.001 13.3333Z",
          fill: "#E9C072"
        }
      )
    ]
  }
);
const VpFlagXkAsset = forwardRef(FlagXkAsset);

export { VpFlagXkAsset as default };
